// Phòng máy của lõi chân dung khách (QĐ 0541).
//
// Bài nằm trong mã trang web mà ai đăng nhập cũng tải được, nên CỐ Ý không nêu
// chỗ máy đoán, dữ kiện máy đọc hay cách máy đoán — chỉ tả cách dùng bốn thẻ.

import type { GuideBook } from "../types";

export const HUNCH_ROOM_GUIDES: GuideBook = {
  hunch_room: {
    purpose: "Nạp, bật và thử bảng luật của máy gợi ý; chỉ người có tên trong phòng mới vào được.",
    where: [
      'Đầu trang: tên trang "Phòng máy" và ba ô tình hình — bản luật đang chạy, số người trong phòng, việc chạy ngầm.',
      'Bốn thẻ ngay dưới: "Thử trên một đơn", "Bảng luật", "Người vào phòng", "Sổ xem/sửa".',
      'Thẻ "Thử trên một đơn": ô "Mã đơn", ô chọn bản luật để thử, nút "Thử máy" và các mã đơn vừa thử.',
      'Thẻ "Bảng luật": nút "Nạp bản luật mới", bảng các bản đã nạp với nút "Thử bản này", "Bật bản này", "Bật lại".',
      'Thẻ "Người vào phòng": thẻ người giữ phòng, thẻ người thứ hai hoặc ô "Thêm người thứ hai".',
      'Thẻ "Sổ xem/sửa": các nút lọc "Tất cả", "Sửa", "Thử đơn", "Bị chặn" kèm số, bảng sổ và nút "Xem thêm 50 dòng".',
    ],
    howItWorks: [
      "Chỉ người có tên trong phòng mới thấy mục menu; người khác gõ thẳng đường dẫn sẽ bị chặn và lần gõ cửa được ghi sổ.",
      "Mỗi lần mở phòng, mở một thẻ, thử một đơn, nạp, bật, thêm hay gỡ người, máy đều tự ghi một dòng sổ — không ai sửa hay xoá được sổ.",
      "Nạp bản luật: máy tự kiểm cả tệp; tệp sai thì hiện từng chỗ sai để sửa, tệp đạt thì thành bản Sẵn sàng, chưa chạy.",
      "Bật bản luật: máy kiểm lại một lần nữa với danh mục hôm nay; bật bản mới thì bản đang chạy tự chuyển sang Đã thay.",
      "Thử trên một đơn chỉ xem, không đổi gì của đơn; máy đọc đơn như lúc đơn vừa tạo.",
      "Trên màn luôn có chữ chìm ghi tên người đang xem — ảnh chụp màn hình nào cũng mang tên người chụp.",
    ],
    statuses: [
      { label: "Sẵn sàng", meaning: "Bản đã nạp và qua kiểm, chưa chạy." },
      { label: "Đang chạy", meaning: "Bản máy đang dùng. Mỗi lúc chỉ có một bản đang chạy." },
      { label: "Đã thôi", meaning: "Bản từng chạy, đã được bản khác thay; bật lại được." },
      { label: "Chưa chắc", meaning: "Máy chưa đủ căn cứ để chọn — xem câu hỏi thêm bên dưới." },
      { label: "BỊ CHẶN", meaning: "Dòng sổ ghi một người không có tên đã gõ cửa phòng." },
    ],
    blocks: [
      {
        for: ["exec"],
        title: "Nạp và bật một bản luật",
        steps: [
          'Mở thẻ "Bảng luật", bấm "Nạp bản luật mới".',
          "Chọn tệp bản luật, kiểm ô Tên bản rồi bấm Nạp.",
          "Có chỗ sai thì sửa tệp theo từng dòng báo rồi nạp lại.",
          'Đạt rồi thì bấm "Thử bản này" để thử vài đơn trước khi bật.',
          'Thấy ổn thì bấm "Bật bản này" và xác nhận.',
        ],
        troubles: [
          "Bật mà báo lỗi: danh mục đã đổi từ lúc nạp — sửa tệp theo dòng báo rồi nạp bản mới.",
          "Nút Nạp bị khoá: chưa chọn tệp hoặc chưa có tên bản.",
        ],
      },
      {
        for: ["exec"],
        title: "Thử máy trên một đơn",
        steps: [
          'Mở thẻ "Thử trên một đơn", gõ mã đơn.',
          "Chọn bản luật muốn thử, để trống là bản đang chạy.",
          'Bấm "Thử máy", đọc từng khối; bấm vào phương án để xem câu làm gì và căn cứ.',
          'Bấm "Xem luật" để xem luật nào đã cộng điểm.',
        ],
        troubles: [
          "Báo chưa có bản luật nào đang chạy: chọn một bản để thử hoặc bật một bản.",
          "Báo không tìm thấy đơn: kiểm lại mã đơn.",
        ],
      },
      {
        for: ["exec"],
        title: "Thêm hoặc gỡ người thứ hai",
        steps: [
          "Chỉ người giữ phòng làm được việc này.",
          'Mở thẻ "Người vào phòng", bấm "Thêm người thứ hai".',
          "Chọn người, nhập ngày ký cam kết giữ bí mật, tích ô đang giữ bản có chữ ký.",
          'Bấm "Thêm vào phòng". Muốn gỡ thì bấm "Gỡ" ở thẻ người đó và xác nhận.',
        ],
        troubles: [
          "Không thấy người cần thêm: danh sách chỉ có những người đang làm việc và đủ vai để vào phòng.",
          "Báo phòng đã đủ hai người: gỡ người thứ hai cũ trước.",
        ],
      },
    ],
    askWho: "Thắc mắc về Phòng máy thì hỏi người giữ phòng.",
  },
};
